export const ROUNDS_AMOUNT = 20;
export const SCORE_PER_WORD = 10;
